export const firstName = (name) => {
  return name.split(' ')[0].trim();
};

export const lastName = (name) => {
  return name.split(' ')[1].trim();
};
